import { render, staticRenderFns } from "./StoryStatisticViewItem.vue?vue&type=template&id=380f6993&scoped=true&"
import script from "./StoryStatisticViewItem.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticViewItem.vue?vue&type=style&index=0&id=380f6993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f6993",
  null
  
)

export default component.exports